import { uniqueId } from "@faire/web--source/common/server-side-rendering/uniqueId";
import React from "react";
/** Use to generate a unique ID within a functional component */ export var useUniqueId = "useId" in React ? function(idPrefix, _propId) {
    return "".concat(idPrefix).concat(React.useId());
} : function(idPrefix, propId) {
    var idRef = React.useRef(propId !== null && propId !== void 0 ? propId : uniqueId(idPrefix));
    return idRef.current;
};
